import type { DesignDefinition } from '../types';

const spring = { type: 'spring', bounce: 0.36 } as const;

/** D · Bento Pop: blocks pop into place on a spring, cubes and balls bob, the badge turns. */
export const bento: DesignDefinition = {
  id: 'bento',
  name: 'Bento Pop',
  nameZh: '缤纷积木',
  description: 'Bold color blocks, cubes and a spinning badge',
  descriptionZh: '饱和色块、立体方块与旋转徽章',
  swatches: ['#7C7FE0', '#FFD27A', '#A8E6DC'],
  preview: {
    canvas: '#F3F3F1',
    ink: '#111114',
    font: '"Quicksand Variable", "Arial Rounded MT Bold", system-ui, sans-serif',
  },
  motion: {
    reveal: { transition: { ...spring, duration: 0.82 }, scale: 0.94 },
    heading: { duration: 1, ease: [0.22, 1, 0.36, 1] },
    clip: { ...spring, duration: 1 },
    stagger: 0.07,
    hover: { y: -6, rotate: -0.6, transition: { type: 'spring', stiffness: 360, damping: 18 } },
    float: { y: -12, duration: 6 },
    layout: { type: 'spring', stiffness: 420, damping: 28 },
  },
};
